import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import { ServicesIndex } from "@/pages/Services";
import ServiceDetail from "@/pages/Services";
import { IndustriesIndex } from "@/pages/Industries";
import IndustryDetail from "@/pages/Industries";
import {
    ContactPage, SupportPage, AboutPage, ServiceAreasPage, ResourcesPage,
    FaqPage, ProjectsPage, SupportPlansPage, PrivacyPage, TermsPage, NotFoundPage,
} from "@/pages/Pages";
import { AdminLogin, ProtectedAdmin } from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import CaseStudyDetail from "@/pages/CaseStudyDetail";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/services" element={<ServicesIndex />} />
                        <Route path="/services/:slug" element={<ServiceDetail />} />
                        <Route path="/industries" element={<IndustriesIndex />} />
                        <Route path="/industries/:slug" element={<IndustryDetail />} />
                        <Route path="/support-plans" element={<SupportPlansPage />} />
                        <Route path="/projects" element={<ProjectsPage />} />
                        <Route path="/projects/:slug" element={<CaseStudyDetail />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/service-areas" element={<ServiceAreasPage />} />
                        <Route path="/resources" element={<ResourcesPage />} />
                        <Route path="/faq" element={<FaqPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/support" element={<SupportPage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
